

define(['jquery', 'squid/index', 'text!./template.html', 'components/xo-ui-components/src/accessibility/directive'], function ($, squid, template) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-language-options.directive', ['squid', 'xo-accessibility.directive']).factory('$GetPomaFlowStatus', function ($pxp, $q) {
        return function (country) {
            return $pxp('XO_XOONBOARDING_POMA_GLOBAL', { 'ctx.COUNTRY': country }, 'XO_XOONBOARDING_POMA_GLOBAL_TREATMENT').then(function (result) {
                if (result && result.treatment_name) {
                    return $q.resolve(true);
                } else {
                    return $q.resolve(false);
                }
            });
        };
    }).directive('xoLanguageOptions', function () {
        return {
            template: template,

            scope: {},

            controller: function controller($scope, $populate, $locale, $Class, $config, $GetPomaFlowStatus, $logger) {
                $scope.showLanguages = false;
                setLanguageVars();

                function removeUnselectableLanguages(supportedLanguages) {
                    var unselectableLanguages = $config.unselectableLanguages || [];
                    for (var i = 0; i < unselectableLanguages.length; i++) {
                        var ul = unselectableLanguages[i];
                        var idx = supportedLanguages.indexOf(ul);
                        if (idx !== -1) {
                            supportedLanguages.splice(idx, 1);
                        }
                    }

                    return supportedLanguages;
                }

                function setLanguageVars() {
                    $scope.localeModel = $locale;
                    $scope.currentLanguage = $scope.localeModel.lang;
                    $scope.currentCountry = $scope.localeModel.country;
                    $scope.languageList = $scope.localeModel.metadata.languageLabel;
                    var supportedLanguages = $config.supportedCountries[$scope.currentCountry];
                    $scope.supportedLanguages = removeUnselectableLanguages(supportedLanguages);
                }

                function logLanguageChange() {
                    var state;
                    if (!isXoonPage()) {
                        state = 'LOGIN';
                        callLogLangChange();
                    } else {
                        $GetPomaFlowStatus($locale.country).then(function (poma_flag) {
                            state = poma_flag ? 'guest_POMA' : 'GUEST_XO';
                            callLogLangChange();
                        });
                    }

                    function callLogLangChange() {
                        $logger.info('checkout_fpti', {
                            'from': state,
                            'to': 'process_language_change'
                        });
                    }
                }

                function isXoonPage() {
                    return $('.singlePagePaymentForm, .multistepSignupForm').length > 0;
                }

                if ($scope.supportedLanguages && $scope.supportedLanguages.length > 1) {
                    $scope.hasMultipleLanguages = true;
                }

                $scope.selectLanguage = function (language) {
                    $scope.currentLanguage = language;
                    $locale.chooseLang(language);
                    logLanguageChange();
                };

                $scope.toggle = function ($event) {
                    if ($event) {
                        $event.preventDefault();
                    }

                    $scope.showLanguages = !$scope.showLanguages;
                };

                // Reset locale properties for languageToggle
                $scope.$on('localeChange', function () {
                    setLanguageVars();
                });

                // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
                $scope.$on('clickBody', function ($event, target) {
                    if ($(target).parents('.languageToggleDisplay div').length === 0) {
                        $scope.showLanguages = false;
                        $scope.$apply();
                    }
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-form-components/src/language-options/directive.js
 ** module id = 198
 ** module chunks = 1
 **/